export default "__VITE_ASSET__Tm5eIk9K__"